<template lang="pug">
  div.body.body-table.garbage-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            div.parameters
            div.actions-panel
              e-button-add(@click="openNewBillForm")

      div
        e-table-editable(
        ref="bankBooks"
        :attributes="attr[this.type]"
        :dataUrl="dataUrl"
        :postUrl="() => null"
        :patchUrl="() => null"
        :deleteUrl="() => null"
        :tableInOnlineMode="tableInOnlineMode"
        @sortByField="onSortByField"
        :enablePagination="true"
        @paginate="onPaginate"
        :onToggleEditable="() => null"
        @afterFetchData="afterFetchDataEvent"
        )
          div(slot="buttons" slot-scope="props")
            button(
            v-if="props.acceptEdit"
            @click.prevent="openBillFormForUpdate(props.model)"
            class="row-edit"
            title="Редактировать"
            )
            button(
            v-if="props.acceptDelete"
            @click.prevent="deleteRow(props.model)"
            class="row-delete"
            title="Удалить"
            )
</template>

<script>
  import url from '../../../utils/url'
  import {wasteGenerators} from '../../../api/api-endpoints.js'
  import {wasteGeneratorsOffline} from '../../../api/api-offline-endpoints.js'
  import {BANK_ACCOUNT_TYPE_LEGAL, BANK_ACCOUNT_TYPE_MKD, BANK_ACCOUNT_TYPE_HOUSE} from "../../../config/config";
  import {BILL_FORM, IS_OWNER} from "../types/types"
  import {transformTableFieldValueToString} from "../../../utils/transformTableFieldValueToString"

  export default {
    name: 'garbage-bank-books',
    props: {
      fields: null,
      tabView: null,
      type: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        operationType: null,
        sort: null,
        paginationQuery: null,
        data: null
      }
    },
    computed: {
      selectListOptions () {
        return [
          {
            id: 'detail',
            name: 'Лицевые счета'
          }
        ]
      },
      tableInOnlineMode () {
        return this.$route.params.id
      },
      endpoint () {
        return {
          [BANK_ACCOUNT_TYPE_LEGAL]: {
            list: wasteGenerators.bankBooksLegals,
            delete: wasteGenerators.bankBookLegalDelete
          },
          [BANK_ACCOUNT_TYPE_MKD]: {
            list: wasteGenerators.bankBookApartments,
            delete: wasteGenerators.bankBookApartmentDelete
          },
          [BANK_ACCOUNT_TYPE_HOUSE]: {
            list: wasteGenerators.bankBookHouses,
            delete: wasteGenerators.bankBookHouseDelete
          }
        }
      },
      metaFields () {
        if (this.data && this.data._meta && this.data._meta.fields) {
          return this.data._meta.fields
        }
        return null
      },
      attr () {
        // забор инф о полях из мета информации
        if (this.metaFields) {
          const attr = {}
          const fields = this.metaFields
          for (let fName in fields) {
            const fieldMeta = fields[fName]
            attr[fName] = {
              ...fieldMeta,
              transform: (model) => transformTableFieldValueToString(model, fName, fieldMeta)
            }
            if (!attr[fName].width) {
              attr[fName].width = 120
            }
          }
          return {
            [this.type]: attr
          }
        }
        // если режим род запись еще не создана
        // то оффлйна режим и берем базовую информацию
        return {
          [BANK_ACCOUNT_TYPE_LEGAL]: {
            number: {
              label: "№ Лицевого счета",
              width: 120
            },
            address: {
              label: "Адрес",
              width: 100
            },
            flat: {
              label: "Номер офиса",
              width: 100
            },
            status: {
              label: 'Статус',
              transform: (model) => model.status ? model.status.name : ' - ',
              width: 80
            }
          },
          [BANK_ACCOUNT_TYPE_MKD]: {
            number: {
              label: "№ Лицевого счета",
              width: 120
            },
            address: {
              label: "Адрес",
              width: 100
            },
            flat: {
              label: "Номер квартиры",
              width: 100
            },
            room: {
              label: "Номер комнаты",
              width: 100
            },
            name: {
              label: 'Владелец',
              transform: this.transformOwnerName
            },
            status: {
              label: 'Статус',
              transform: (model) => model.status ? model.status.name : ' - ',
              width: 80
            }
          },
          [BANK_ACCOUNT_TYPE_HOUSE]: {
            number: {
              label: "№ Лицевого счета",
              width: 120
            },
            address: {
              label: "Адрес",
              width: 100
            },
            flat: {
              label: "Номер квартиры",
              width: 100
            },
            name: {
              label: 'Владелец',
              transform: this.transformOwnerName
            },
            status: {
              label: 'Статус',
              transform: (model) => model.status ? model.status.name : ' - ',
              width: 80
            }
          }
        }
      },
      dataUrl () {
        if (this.tableInOnlineMode) {
          const sourceId = this.$route.params.id
          let routeQuery = {
            query: {
            }
          }
          if (this.sort) {
            routeQuery.query.sort = this.sort
          }
          if (this.paginationQuery) {
            routeQuery.query = Object.assign(routeQuery.query, this.paginationQuery)
          }

          return this.endpoint[this.type].list(routeQuery, sourceId)
        }

        return wasteGeneratorsOffline.bankBooks()
      }
    },
    created () {
      this.subsOnSave = this.$emitter.listen('form', (e) => this.onFormMutate(e))
      this.subsOnRemove = this.$emitter.listen('form', (e) => this.onFormMutate(e))
    },
    destroyed () {
      this.subsOnSave.unsubscribe()
      this.subsOnRemove.unsubscribe()
    },
    methods: {
      transformOwnerName (model) {
        let fio = ''
        if (Array.isArray(model.individual)) {
          model.individual.forEach(i => {
            if (i.is_owner === IS_OWNER) {
              fio = i.fullName
            }
          })
        }
        return fio
      },
      afterFetchDataEvent ({response}) {
        this.data = Object.assign({}, response.data || {})
      },
      getDeleteUrl (id) {
        return this.endpoint[this.type].delete(id)
      },
      onFormMutate (e) {
        if (e.name === BILL_FORM && (e.action === 'onSaveForm' || e.action === 'onRemove')) {
          this.$refs.bankBooks && this.$refs.bankBooks.fetchData()
        }
      },
      onPaginate (paginationQuery) {
        this.paginationQuery = paginationQuery
      },
      onSortByField ({sort}) {
        this.sort = sort
      },
      deleteRow (model) {
        this.$e.confirmBox().then(() => {
          this.$store.dispatch('deleteModel', {
            url: this.getDeleteUrl(model.id),
            offline: (!model.id),
            data: model,
            endpoint: wasteGeneratorsOffline.bankBooks()
          }).then(() => {
            this.$e.successBox('Запись удалена')
            this.$emitter.emit('form', {
              action: 'onRemove',
              name: BILL_FORM
            })
          }).catch(erResponse => {
            this.$e.errorBox(erResponse)
          })
        })
      },
      getPreparedRedirectRoute () {
        let prevRoute = url.getRoute(this.$route, true)
        let redirectTo = url.getRoute(this.$route)
        redirectTo.query = {prevRoute}
        return redirectTo
      },
      openBillFormForUpdate (model) {
        let rT = this.getPreparedRedirectRoute()
        this.$router.push({
          name: rT.name + '.billUpdate',
          params: {
            ...rT.params,
            objectId: model.id || model._storeUUID
          },
          query: rT.query
        })
      },
      openNewBillForm () {
        // if (!this.$route.params.id) {
        //   this.$e.warningBox('Вы сможете добавлять лицевые счета после сохранения')
        //   return
        // }
        let rT = this.getPreparedRedirectRoute()
        this.$router.push({
          name: rT.name + '.billCreate',
          params: rT.params,
          query: rT.query
        })
      }
    }
  }
</script>
